/**
 * Object pool genérico — evita alocar/coletar lixo todo frame.
 * Usado por números de dano; preparado para inimigos, projéteis e efeitos futuros.
 */
export class Pool<T> {
  private free: T[] = [];

  constructor(
    private readonly factory: () => T,
    private readonly onReset: (obj: T) => void,
    prewarm = 0,
  ) {
    for (let i = 0; i < prewarm; i++) this.free.push(this.factory());
  }

  acquire(): T {
    return this.free.pop() ?? this.factory();
  }

  release(obj: T): void {
    this.onReset(obj);
    this.free.push(obj);
  }
}
